export const VehicleType = [
  "Toco",
  "Trucado",
  "3/4",
  "VUC",
  "Cavalo Mecânico",
  "Outro"
];